<template>
    <div class="page-iframe content">
        <YScroll style="height: 100%;">
            <!-- 测试地址：http://localhost:88/admin/iframe/fcs/task/detail -->
            <iframe id="taskDetailFrame" :src="'/admin/iframe/fcs/task/detail?taskId='+taskId+'&pageMode='+pageMode+'&activeTab='+page"
                style="width: 100%; height: 86vh;" />
                <!-- height:calc(100vh - 120px) -->
        </YScroll>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import Pagination from '@/page/taskPage/common/Pagination';

export default {
    components: { Pagination, YScroll },
    props: {
        appCode: {
            type: String,
            default: '',
        },
        taskId: {
            type: String,
            default: '',
        },
        pageMode: {
            type: String,
            default: '',
        },
        page: {
            type: String,
            default: 'base',
        },
        upload: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
        };
    },
    watch: {

    },
    created() { },

    mounted() {
        // 获取window高度，并赋值给iframe的高度
        window.addEventListener('resize', () => {
            document.querySelector('#taskDetailFrame').style.height = 'height:calc(100vh - 120px)';
        });

        let that = this;
        // 接收子frame传来的数据
        window.addEventListener('message', (e) => {
            console.log('listen postMessage: ', e.data);
            if (e.data.type === 'closeRequestForm') {
                // that.$emit('close', e.data.op=='submit');
                that.closePage(e.data.op == 'submit');
            }
        });
    },
    methods: {
        closePage(update) {
            console.log('closePage: ', update);
            this.$emit('close', update || false);
        },

    },
};
</script>

<style lang="scss">
.content{
    height: 99%;
}
</style>
